import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Card, Col, Empty, Flex, Form, Input, InputNumber, message, Row, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useParams } from "react-router";
import { useEffect } from "react";
import { ratePerCommodityService } from "../../../services/rate-per-commodity.service";
import { Icon } from "@iconify/react/dist/iconify.js";
import RenderIf from "../../../components/RenderIf";

const idrFormatter = {
  formatter: value => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
  parser: value => value.replace(/\Rp\s?|(\.)|[^\d]/g, '')
}

export default function RatePerCommodityForm(){

  const { id } = useParams()

  const [form] = useForm()
  const navigate = useNavigate()

  const { data: ratePerCommodity  } = useQuery({
    queryKey: ['detailRatePerCommodity', id],
    queryFn: () => ratePerCommodityService.getById(id),
    enabled: !!id
  })

  useEffect(() => {
    if(id){
      form.setFieldsValue(ratePerCommodity?.data)
      console.log(ratePerCommodity?.data)
      form.setFieldValue(
        'fisika_kimia',
        ratePerCommodity?.data.parameter
        .filter(e => e.type == 'fisika_kimia')
        .map(e => e.name)
      )
      form.setFieldValue(
        'mikrobiologi',
        ratePerCommodity?.data.parameter
        .filter(e => e.type == 'mikrobiologi')
        .map(e => e.name)
      )
      form.setFieldValue(
        'fisika_kimia_komersil',
        ratePerCommodity?.data.price
        .filter(e => e.type == 'fisika_kimia' && e.price_type == 'komersil')[0].amount
      )
      form.setFieldValue(
        'fisika_kimia_non_komersil',
        ratePerCommodity?.data.price
        .filter(e => e.type == 'fisika_kimia' && e.price_type == 'non-komersil')[0].amount
      )
      form.setFieldValue(
        'fisika_kimia_express',
        ratePerCommodity?.data.price
        .filter(e => e.type == 'fisika_kimia' && e.price_type == 'express')[0].amount
      )
      form.setFieldValue(
        'mikrobiologi_komersil',
        ratePerCommodity?.data.price
        .filter(e => e.type == 'mikrobiologi' && e.price_type == 'komersil')[0].amount
      )
      form.setFieldValue(
        'mikrobiologi_non_komersil',
        ratePerCommodity?.data.price
        .filter(e => e.type == 'mikrobiologi' && e.price_type == 'non-komersil')[0].amount
      )
      form.setFieldValue(
        'mikrobiologi_express',
        ratePerCommodity?.data.price
        .filter(e => e.type == 'mikrobiologi' && e.price_type == 'express')[0].amount
      )
    }

  }, [ratePerCommodity, form, id])

  const storeMutation = useMutation({
    mutationFn: (data) => ratePerCommodityService.store(data),
    onSuccess: () => {
      message.success('Data berhasil disimpan');
      form.resetFields();
      navigate('/lab-service/rate-per-commodity')
    },
    onError: (error) => {
      console.log(error)
      message.error('Terjadi Kesalahan');
    }
  })

  const updateMutation = useMutation({
    mutationFn: (data) => ratePerCommodityService.update(data),
    onSuccess: () => {
      message.success('Data berhasil diubah');
      form.resetFields();
      navigate('/lab-service/rate-per-commodity')
    },
    onError: (error) => {
      console.log(error)
      message.error('Terjadi Kesalahan');
    }
  })

  const mikrobiologiExpress = Form.useWatch('mikrobiologi_express', form)
  const fisikaExpress = Form.useWatch('fisika_kimia_express', form)

  const mikrobiologiKomersil = Form.useWatch('mikrobiologi_komersil', form)
  const fisikaKomersil = Form.useWatch('fisika_kimia_komersil', form)

  const mikrobiologiNonKomersil = Form.useWatch('mikrobiologi_non_komersil', form)
  const fisikaNonKomersil = Form.useWatch('fisika_kimia_non_komersil', form)

  useEffect(() => {
    form.setFieldValue('express_total', (mikrobiologiExpress ?? 0) + (fisikaExpress ?? 0))
  }, [mikrobiologiExpress, fisikaExpress, form])

  useEffect(() => {
    form.setFieldValue('komersil_total', (mikrobiologiKomersil ?? 0) + (fisikaKomersil ?? 0))
  }, [fisikaKomersil, mikrobiologiKomersil, form])

  useEffect(() => {
    form.setFieldValue('non_komersil_total', (mikrobiologiNonKomersil ?? 0) + (fisikaNonKomersil ?? 0))
  }, [fisikaNonKomersil, mikrobiologiNonKomersil, form])

  const handleSubmit = (val) => {

    const price = [
      {
        amount: val.fisika_kimia_komersil,
        type: 'fisika_kimia',
        price_type: 'komersil'
      },
      {
        amount: val.fisika_kimia_non_komersil,
        type: 'fisika_kimia',
        price_type: 'non-komersil'
      },
      {
        amount: val.fisika_kimia_express,
        type: 'fisika_kimia',
        price_type: 'express'
      },
      {
        amount: val.mikrobiologi_komersil,
        type: 'mikrobiologi',
        price_type: 'komersil'
      },
      {
        amount: val.mikrobiologi_non_komersil,
        type: 'mikrobiologi',
        price_type: 'non-komersil'
      },
      {
        amount: val.mikrobiologi_express,
        type: 'mikrobiologi',
        price_type: 'express'
      },
    ]

    const formatted_mikrobiologi_parameter = val.mikrobiologi.map(e => ({ name: e, type: 'mikrobiologi' }))
    const formatted_fisika_kimia_parameter = val.fisika_kimia.map(e => ({ name: e, type: 'fisika_kimia' }))

    const data = {
      ...val,
      price,
      parameter: [ ...formatted_fisika_kimia_parameter, ...formatted_mikrobiologi_parameter ]
    }

    if(!id) storeMutation.mutate(data)
    else updateMutation.mutate(data)
  }

  return (
    <>
      <Card
        title={ (id ? "Ubah" : "Tambah") + " Data"}
        actions={[
          <Flex key={1} justify="end" style={{ paddingRight: 24 }} gap={16} >
            <Button onClick={() => navigate('/lab-service/rate-per-commodity')} variant="outlined" color="primary" >
              Batal
            </Button>
            <Button 
              variant="solid" 
              color="primary" 
              onClick={() => form.submit()}
            >
              Simpan
            </Button>
          </Flex>
        ]}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          <Form.Item hidden name={'id'} >
            <Input/>
          </Form.Item>
          <Form.Item
            name={'name'}
            label="Nama Layanan"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
          {/* <Divider orientation="left" >Fisika & Kimia</Divider> */}
          <Typography.Title level={5} style={{ fontWeight: 500, marginBottom: 12 }} >
            Fisika & Kimia
          </Typography.Title>
          <Form.List  
            name='fisika_kimia' 
            rules={[
              {
                validator: async (_, fields) => {
                  if (!fields || fields.length < 1) {
                    return Promise.reject(new Error('Parameter minimal 1'));
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                <RenderIf when={fields.length == 0} >
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Belum ada parameter" />
                </RenderIf>
                {fields.map((field,index) => (
                  <Flex key={index}  style={{ width: '100%' }} gap={14} >
                    <Typography.Text style={{ fontSize: 14, marginTop: 5, width: 12 }} >
                      {index+1}
                    </Typography.Text>
                    <Form.Item
                      name={field.name}
                      style={{ width: '100%' }}
                      rules={[
                        {
                          required: true,
                          message: 'Parameter harus diisi',
                        },
                      ]}
                    >
                      <Input placeholder="parameter" style={{ width: '100%' }} />
                    </Form.Item>
                    <Button
                      variant="filled"
                      color="danger"
                      onClick={() => remove(field.name)}
                      icon={
                        <Icon
                          icon='solar:trash-bin-trash-bold-duotone'
                          width={21}
                          height={21}
                          style={{ marginBottom: -2 }}
                        />
                      }
                    />
                  </Flex>
                ))}
                <Flex justify={ fields.length == 0 ? "center" : "end"} >
                  <Button variant="filled" color="primary" onClick={() => add()} >
                    Tambah Data
                  </Button>
                </Flex>
                <Form.Item>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
                
              </>
            )}
          </Form.List>
          <Row gutter={[20]} style={{ marginTop: 14 }} >
            <Col span={8} >
              <Form.Item 
                label='Harga Non Komersil'
                name={'fisika_kimia_non_komersil'}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <InputNumber 
                  style={{ width: '100%' }}
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item 
                label='Harga Komersil'
                name={'fisika_kimia_komersil'}
                rules={[
                  {
                    required: true
                  },
                ]}
              >
                <InputNumber 
                  style={{ width: '100%' }} 
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item 
                label='Harga Express'
                name={'fisika_kimia_express'}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
          </Row>
          <Typography.Title level={5} style={{ fontWeight: 500, marginBottom: 12 }} >
            Mikrobiologi
          </Typography.Title>
          <Form.List 
            name='mikrobiologi' 
            rules={[
              {
                validator: async (_, fields) => {
                  if (!fields || fields.length < 1) {
                    return Promise.reject(new Error('Parameter minimal 1'));
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                <RenderIf when={fields.length == 0} >
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Belum ada parameter" />
                </RenderIf>
                {fields.map((field,index) => (
                  <Flex key={index}  style={{ width: '100%' }} gap={14} >
                    <Typography.Text style={{ width: 20, fontSize: 14, marginTop: 5 }} >
                      {index+1}
                    </Typography.Text>
                    <Form.Item
                      name={field.name}
                      style={{ width: '100%' }}
                      rules={[
                        {
                          required: true,
                          message: 'Parameter harus diisi',
                        },
                      ]}
                    >
                      <Input placeholder="parameter" style={{ width: '100%' }} />
                    </Form.Item>
                    <Button
                      variant="filled"
                      color="danger"
                      onClick={() => remove(field.name)}
                      icon={
                        <Icon
                          icon='solar:trash-bin-trash-bold-duotone'
                          width={21}
                          height={21}
                          style={{ marginBottom: -2 }}
                        />
                      }
                    />
                  </Flex>
                ))}
                <Flex justify={ fields.length == 0 ? "center" : "end"} >
                  <Button variant="filled" color="primary" onClick={() => add()} >
                    Tambah Data
                  </Button>
                </Flex>
                <Form.Item>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
          <Row gutter={[20]} style={{ marginTop: 14 }} >
            <Col span={8} >
              <Form.Item 
                label='Harga Non Komersil'
                name={'mikrobiologi_non_komersil'}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <InputNumber 
                  style={{ width: '100%' }}
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item 
                label='Harga Komersil'
                name={'mikrobiologi_komersil'}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <InputNumber 
                  style={{ width: '100%' }}
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item 
                label='Harga Express'
                name={'mikrobiologi_express'}
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <InputNumber 
                  style={{ width: '100%' }}
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
          </Row>
          <Typography.Title level={5} style={{ fontWeight: 500, marginBottom: 12 }} >
            Total Harga
          </Typography.Title>
          <Row gutter={[20]} style={{ marginTop: 14 }} >
            <Col span={8} >
              <Form.Item 
                label='Harga Non Komersil'
                name={'non_komersil_total'}
              >
                <InputNumber
                  readOnly
                  style={{ width: '100%' }}
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item 
                label='Harga Komersil'
                name={'komersil_total'}
              >
                <InputNumber
                  readOnly
                  style={{ width: '100%' }}
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item 
                label='Harga Express'
                name={'express_total'}
              >
                <InputNumber
                  readOnly
                  style={{ width: '100%' }}
                  {...idrFormatter}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  )
}